import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../../components/footer/footer.component';
import { CommonHeaderComponent } from '../../../../components/common-header/common-header.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'donottravel',
  standalone: true,
  imports: [FooterComponent, CommonHeaderComponent, CommonModule],
  templateUrl: './world2coverawards.component.html',
  styleUrl: './world2coverawards.component.scss',
})
export class World2coverawardsComponent {
  constructor(
    private sanitizer: DomSanitizer,
    private titleService: Title,
    private metaService: Meta,
  ) {}
  pageContent: SafeHtml = '';
  pageTitleImg: string = '';
  pageHead: string = '';

  ngOnInit() {
    this.titleService.setTitle(
      'Award-Winning Travel Insurance | Canstar Rated | World2Cover',
    );
    this.metaService.updateTag({
      name: 'description',
      content: `World2Cover is proud to receive Canstar's Outstanding Value Travel Insurance Award: International (2022-24), Cruise (2024), Seniors Cover (2017-19).`,
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Award-Winning Travel Insurance | Canstar Rated | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content: `World2Cover is proud to receive Canstar's Outstanding Value Travel Insurance Award: International (2022-24), Cruise (2024), Seniors Cover (2017-19).`,
    });
    this.pageTitleImg = 'assets/images/w2c/page-header/awards.jpg';
    this.pageHead = `World2Cover Travel Insurance Awards | Canstar Recognition`;
  }
}
